import { Button, Dialog, DialogTitle } from "@mui/material";
import { type FC, useState } from "react";
import { isEmailChannel, type ChannelName } from "../../../../channels/types";
import type { UUID } from "../../../../../utils/uuid";
import { SendTestGuidance } from "./send-test-guidance";
import { SendTestToEmail } from "./send-test-to-email";
import { SendTestToRecipient } from "./send-test-to-recipient";

export const SavedMomentSendTestButton: FC<{ momentId: UUID; channel: ChannelName }> = ({
  momentId,
  channel,
}) => {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const close = (): void => {
    setOpen(false);
    setSaving(false);
  };

  const guidance = <SendTestGuidance />;

  return (
    <>
      <Button
        data-analytics-id="moment-review-send-test"
        variant="outlined"
        loading={saving}
        onClick={() => setOpen(true)}
      >
        Send Test
      </Button>
      <Dialog open={open} onClose={close} fullWidth>
        <DialogTitle>Send Test</DialogTitle>
        {isEmailChannel(channel) ? (
          <SendTestToEmail
            id={momentId}
            setSaving={setSaving}
            publishing={false}
            setTestDialog={setOpen}
          >
            {guidance}
          </SendTestToEmail>
        ) : (
          <SendTestToRecipient
            id={momentId}
            setSaving={setSaving}
            publishing={false}
            setTestDialog={setOpen}
            channel={channel}
          >
            {guidance}
          </SendTestToRecipient>
        )}
      </Dialog>
    </>
  );
};
